const options = {
  rootMargin: '-25%',
}

const callback = (entries) => {
  for (const entry of entries) {
    if (entry.isIntersecting) {
      entry.target.classList.add('reveal')
    }
  }
}

const observer = new IntersectionObserver(callback, options)
const medias = document.querySelectorAll(
  '.o-hero .items, .medias .wrapper, .n-medias .list'
)

for (const media of medias) {
  observer.observe(media)
}
